module.exports = __webpack_public_path__ + "img/8.56a57ddd.jpg";